<template>
  <div>
    <v-app-bar dense dark>
      <v-app-bar-nav-icon @click="mostrarSideBar"></v-app-bar-nav-icon>
      <v-app-bar-title>
        <span v-if="isAuthenticated"
          class="headline font-weight-light clickable"
          @click="abrirOpcion('Home')"
          >{{ appTitulo }}</span
        >
        <span v-else
          class="headline font-weight-light"
          >{{ appTitulo }}</span
        >
      </v-app-bar-title>
    </v-app-bar>
    <v-navigation-drawer
      v-model="sideBarActiva"
      absolute
      dark
      temporary
      class="transparente"
    >
      <v-list class="blue-grey darken-4">
        <v-list-item v-if="isAuthenticated" @click="abrirOpcion('Home')">
          <v-list-item-avatar>
            <v-icon>account_circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <small class="caption font-weight-light"
              >{{ nombreUsuario }} | {{ nombreRol }}</small
            >
            <v-list-item-title class="overline">{{
              nombreUsuarioEmpleado
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item v-else @click="abrirOpcion('Login')">
          <v-list-item-action>
            <v-icon>lock_open</v-icon>
          </v-list-item-action>
          <v-list-item-title>Iniciar</v-list-item-title>
        </v-list-item> -->
      </v-list>
      <v-list dense v-if="isAuthenticated">
        <div v-if="menuPos1">
          <v-list-group prepend-icon="thumb_up">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Venta</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsVentaPos"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-title>{{ item.titulo }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group prepend-icon="attach_money" :value="true">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Caja</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsCajaPos"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-title>{{ item.titulo }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group prepend-icon="view_quilt">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Stock</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsStockPos"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-title>{{ item.titulo }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
        <div v-if="menuAdministracion">
          <v-list-group prepend-icon="thumb_up" :value="false">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Venta</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsVenta"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsVentaArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsVentaReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group prepend-icon="attach_money">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Caja</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsCaja"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCajaArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCajaReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group prepend-icon="credit_card">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Tarjeta</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsTarjeta"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsTarjetaArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group prepend-icon="local_atm">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Cartera</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsCartera"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCarteraArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCarteraReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group prepend-icon="account_balance">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Banco</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsBanco"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsBancoArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsBancoReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group prepend-icon="view_quilt">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Stock</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsStock"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsStockArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsStockReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group prepend-icon="local_shipping">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Compra</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsCompra"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCompraArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCompraReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group prepend-icon="group">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Personal</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsPersonal"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-title>{{ item.titulo }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group prepend-icon="settings">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Sistema</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsSistema"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsSistemaArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsSistemaReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
        </div>
        <div v-if="menuBanco">
          <v-list-group prepend-icon="account_balance" :value="true">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Banco</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsBanco"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsBancoArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsBancoReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
        </div>
        <div v-if="menuCartera">
          <v-list-group prepend-icon="local_atm" :value="true">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Cartera</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsCartera"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCarteraArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCarteraReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
        </div>
        <div v-if="menuCompra">
          <v-list-group prepend-icon="local_shipping" :value="true">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Compra</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsCompra"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCompraArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsCompraReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
        </div>
        <div v-if="menuVenta">
          <v-list-group prepend-icon="thumb_up" :value="true">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Venta</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="item in itemsVenta"
              :key="item.titulo"
              @click="abrirOpcion(item.ruta)"
              class="grey darken-4"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Archivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsVentaArchivo"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-group sub-group class="grey darken-4">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Reportes</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="item in itemsVentaReportes"
                :key="item.titulo"
                @click="abrirOpcion(item.ruta)"
                class="grey darken-4"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
        </div>
      </v-list>
      <v-list dense>
        <v-list-item
          class="blue-grey--text text--lighten-1"
          v-if="isAuthenticated"
          @click="logout"
        >
          <v-list-item-action>
            <v-icon>lock</v-icon>
          </v-list-item-action>
          <v-list-item-title>Salir</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { AUTH_LOGOUT } from "@/store/store";
export default {
  name: "EncabezadoPagina",
  data() {
    return {
      sideBarActiva: false,
      itemsVentaPos: [
        { titulo: "Facturador", ruta: "Venta" },
        { titulo: "Clientes", ruta: "ClienteCrud" },
        {
          titulo: "Ficha del Cliente",
          ruta: "VentaListarPorCliente"
        }
      ],
      itemsCajaPos: [
        { titulo: "Corte de Turno", ruta: "CajaPosCorte" },
        { titulo: "Cierre de Turno", ruta: "CajaPosCierreP" }
      ],
      itemsStockPos: [
        {
          titulo: "Consulta de Precios",
          ruta: "ArticuloConsultaPrecio"
        }
      ],
      itemsVenta: [
        { titulo: "Facturador", ruta: "Venta" },
        {
          titulo: "Carga Manual",
          ruta: "VentaManual"
        },
        {
          titulo: "Anula Impresión Fiscal",
          ruta: "AnulaImpresionFiscal"
        },
        {
          titulo: "Genera Factura Electrónica",
          ruta: "GeneraFE"
        }
      ],
      itemsVentaArchivo: [{ titulo: "Clientes", ruta: "ClienteCrud" }],
      itemsVentaReportes: [
        {
          titulo: "Ficha del Cliente",
          ruta: "VentaListarPorCliente"
        },
        {
          titulo: "Saldos Deudores",
          ruta: "VentaListarSaldos"
        },
        {
          titulo: "Libro IVA Ventas",
          ruta: "VentaListarLibroIva"
        },
        {
          titulo: "Libro Percepciones IIBB",
          ruta: "VentaListarLibroPercepcionIb"
        }
      ],
      itemsCaja: [
        {
          titulo: "Cierre de Turno",
          ruta: "CajaPosCierreA"
        },
        { titulo: "Cierre de Caja", ruta: "CajaCierreP" }
      ],
      itemsCajaArchivo: [{ titulo: "Planillas", ruta: "CajaCrud" }],
      itemsCajaReportes: [
        {
          titulo: "Saldos de Caja",
          ruta: "CajaListarSaldos"
        }
      ],
      itemsTarjeta: [{ titulo: "Cupones", ruta: "CuponCrud" }],
      itemsTarjetaArchivo: [{ titulo: "Tarjetas", ruta: "TarjetaCrud" }],
      itemsCartera: [
        {
          titulo: "Cheques de Tercero",
          ruta: "ChequeTerceroCrud"
        }
      ],
      itemsCarteraArchivo: [{ titulo: "Bancos", ruta: "BancoCrud" }],
      itemsCarteraReportes: [
        {
          titulo: "Cartera de Cheques",
          ruta: "ChequeTerceroListarPorEstado"
        }
      ],
      itemsBanco: [
        {
          titulo: "Cheques",
          ruta: "ChequeCrud"
        },
        {
          titulo: "Chequeras",
          ruta: "ChequeraCrud"
        }
      ],
      itemsBancoArchivo: [
        {
          titulo: "Cuentas Bancarias",
          ruta: "CuentaBancariaCrud"
        },
        { titulo: "Bancos", ruta: "BancoCrud" }
      ],
      itemsBancoReportes: [
        {
          titulo: "Cheques por Chequera",
          ruta: "ChequeListarPorChequera"
        },
        {
          titulo: "Cheques por Fecha Pago",
          ruta: "ChequeListarPorFechaPago"
        }
      ],
      itemsStock: [
        {
          titulo: "Consulta de Precios",
          ruta: "ArticuloConsultaPrecio"
        }
        // {
        //   titulo: "Cambio de Precios",
        //   ruta: "ArticuloCambioPrecio"
        // }
      ],
      itemsStockArchivo: [
        { titulo: "Artículos", ruta: "ArticuloCrud" },
        { titulo: "Rubros", ruta: "RubroCrud" },
        { titulo: "Subrubros", ruta: "SubrubroCrud" },
        { titulo: "Marcas", ruta: "MarcaCrud" },
        { titulo: "Rubros IIBB", ruta: "RubroIbCrud" },
        { titulo: "Teclas de Función", ruta: "TeclaCrud" }
      ],
      itemsStockReportes: [
        {
          titulo: "Lista de Precios",
          ruta: "StockListarPrecios"
        },
        {
          titulo: "Inventario",
          ruta: "StockListarSaldos"
        },
        {
          titulo: "Ficha del Artículo",
          ruta: "StockListarFicha"
        }
      ],
      itemsCompra: [{ titulo: "Comprobantes", ruta: "Compra" }],
      itemsCompraArchivo: [{ titulo: "Proveedores", ruta: "ProveedorCrud" }],
      itemsCompraReportes: [
        {
          titulo: "Ficha del Proveedor",
          ruta: "CompraListarPorProveedor"
        },
        {
          titulo: "Saldos Acreedores",
          ruta: "CompraListarSaldos"
        },
        {
          titulo: "Libro IVA Compras",
          ruta: "CompraListarLibroIva"
        }
      ],
      itemsPersonal: [{ titulo: "Empleados", ruta: "EmpleadoCrud" }],
      itemsSistema: [
        {
          titulo: "Anula Comprobante",
          ruta: "ComprobanteAnularPorTipoComprobante"
        },
        {
          titulo: "Control de Numeración",
          ruta: "ComprobanteControlarNumeracionPorTipoComprobante"
        }
      ],
      itemsSistemaArchivo: [
        { titulo: "Configuración", ruta: "SistemaCrud" },
        { titulo: "Puntos de Venta", ruta: "PuntoVentaCrud" },
        {
          titulo: "Tipos de Comprobante",
          ruta: "TipoComprobante_TalonarioCrud"
        },
        { titulo: "Talonarios", ruta: "TalonarioCrud" },
        { titulo: "Usuarios", ruta: "UsuarioCrud" },
        {
          titulo: "Crear Backup",
          ruta: "CreaBackup"
        }
      ],
      itemsSistemaReportes: [
        {
          titulo: "Comprobantes por Tipo",
          ruta: "ComprobanteListarPorTipoComprobante"
        }
      ]
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    appMenu() {
      return this.$store.state.appMenu;
    },
    appTitulo() {
      return this.$store.state.appTitulo
        ? this.$store.state.appTitulo
        : "Bienvenido";
    },
    nombreUsuario() {
      return this.$store.state.nombreUsuario;
    },
    nombreUsuarioEmpleado() {
      return this.$store.state.nombreUsuarioEmpleado;
    },
    nombreRol() {
      return this.$store.state.nombreRol;
    },
    menuPos1() {
      return this.appMenu == this.$menuPos1;
    },
    menuAdministracion() {
      return this.appMenu == this.$menuAdministracion;
    },
    menuBanco() {
      return this.appMenu == this.$menuBanco;
    },
    menuCartera() {
      return this.appMenu == this.$menuCartera;
    },
    menuCompra() {
      return this.appMenu == this.$menuCompra;
    },
    menuVenta() {
      return this.appMenu == this.$menuVenta;
    }
  },
  methods: {
    abrirOpcion(ruta, params) {
      if (ruta != this.$route.name) {
        if (this.isAuthenticated)
          this.$router.push({ name: ruta, params: params });
        else
          this.$router.push({ name: "Landing" });
      }
    },
    mostrarSideBar() {
      this.sideBarActiva = true;
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.abrirOpcion("Landing");
      });
    }
  }
};
</script>

<style>
.clickable {
  cursor: pointer;
}

.transparente {
  opacity: 0.75;
}
</style>
